// ⚠️ FICHIER GENERE AUTOMATIQUEMENT — NE JAMAIS MODIFIER A LA MAIN.
// Source de verite : taxonomy/gively-taxonomy.json
// Regenerer : cd frontend && npm run generate-taxonomy
// Toute edition manuelle sera ecrasee et fera echouer la CI (check-taxonomy).
/* eslint-disable */
export const TAXONOMY = {
  "$schema": "gively-taxonomy/v1",
  "version": 1,
  "_note": "SOURCE DE VERITE UNIQUE de la taxonomie Gively (Lucas + ChatGPT, juillet 2026). TOUT derive de ce fichier: backend Python, front React (generation au build), SEO, moderation, recherche, tests, documentation. L'API peut l'exposer mais n'en est jamais la source. REGLES: (1) un id de categorie/sous-categorie n'est JAMAIS renomme ni supprime (cle stockee en base) - on ajoute seulement. (2) les slugs deja indexes ne changent pas sans 301. (3) toute categorie ajoutee ici doit apparaitre dans tous les consommateurs (test de coherence bloquant scripts/check-taxonomy.js). Ce fichier reproduit FIDELEMENT l'etat de juillet 2026 (11 racines) - aucune nouvelle categorie tant que la convergence (LOT C) n'est pas terminee (cf. TAXONOMY_SOURCE_OF_TRUTH.md principe permanent).",
  "_facets": {
    "id": "cle immuable, stockee en base (category/subcategory)",
    "label": "libelle long affiche (publication, backend name) - modifiable",
    "pillLabel": "libelle court des pilules de filtre (accueil/recherche)",
    "icon": "nom d'icone backend",
    "slug": "slug SEO FR (stable une fois indexe)",
    "seoName": "libelle SEO des pages programmatiques, ACCENTUE (20/10/2026 : il etait ecrit sans accents et s'affichait tel quel dans le titre Google, ex. « Vehicules ») ; jamais utilise pour construire une URL (les URL viennent de slug)",
    "types": "types d'annonce autorises pour cette branche: sale | rental | service | free"
  },
  "rootOrder": [
    "electronics",
    "vehicles",
    "home",
    "fashion",
    "shoes",
    "sports",
    "culture",
    "kids",
    "pets",
    "services",
    "other"
  ],
  "pillOrder": [
    "fashion",
    "electronics",
    "home",
    "sports",
    "kids",
    "culture",
    "shoes",
    "vehicles",
    "pets",
    "services",
    "other"
  ],
  "seoOrder": [
    "fashion",
    "electronics",
    "home",
    "vehicles",
    "shoes",
    "sports",
    "culture",
    "kids",
    "pets",
    "services",
    "other"
  ],
  "topCats": [
    "mode",
    "electronique",
    "maison",
    "vehicules",
    "livres-culture",
    "enfants-bebes"
  ],
  "categories": {
    "electronics": {
      "id": "electronics",
      "label": "Électronique",
      "pillLabel": "Électronique",
      "icon": "laptop",
      "slug": "electronique",
      "seoName": "Électronique",
      "h1": "Électronique d'occasion solidaire",
      "types": [
        "sale",
        "rental",
        "free"
      ],
      "subcategories": [
        {
          "id": "phones",
          "label": "Téléphones",
          "slug": "telephones",
          "seoName": "Téléphones"
        },
        {
          "id": "computers",
          "label": "Ordinateurs",
          "slug": "ordinateurs",
          "seoName": "Ordinateurs"
        },
        {
          "id": "tablets",
          "label": "Tablettes",
          "slug": "tablettes",
          "seoName": "Tablettes"
        },
        {
          "id": "tv_video",
          "label": "TV & Vidéo",
          "slug": "tv-video",
          "seoName": "TV & Vidéo"
        },
        {
          "id": "audio",
          "label": "Audio & Hi-Fi",
          "slug": "audio-hifi",
          "seoName": "Audio & Hi-Fi"
        },
        {
          "id": "photo",
          "label": "Photo & Caméras",
          "slug": "photo-cameras",
          "seoName": "Photo & Caméras"
        },
        {
          "id": "gaming",
          "label": "Jeux vidéo & Consoles",
          "slug": "jeux-video",
          "seoName": "Jeux vidéo & Consoles"
        },
        {
          "id": "accessories",
          "label": "Accessoires",
          "slug": "accessoires-electronique",
          "seoName": "Accessoires"
        }
      ],
      "deprecated": false,
      "attributes": [
        {
          "id": "brand",
          "name": "Marque",
          "type": "select",
          "required": false,
          "options": [
            "Apple",
            "Samsung",
            "Sony",
            "LG",
            "Huawei",
            "Xiaomi",
            "Google",
            "OnePlus",
            "Asus",
            "HP",
            "Dell",
            "Lenovo",
            "Autre"
          ]
        },
        {
          "id": "model",
          "name": "Modèle",
          "type": "text",
          "required": false,
          "placeholder": "Ex: iPhone 14, Galaxy S23..."
        },
        {
          "id": "condition",
          "name": "État",
          "type": "select",
          "required": true,
          "options": [
            "Neuf",
            "Reconditionné",
            "Très bon état",
            "Bon état",
            "État satisfaisant",
            "Pour pièces"
          ]
        },
        {
          "id": "storage",
          "name": "Capacité / Stockage",
          "type": "select",
          "required": false,
          "options": [
            "16 Go",
            "32 Go",
            "64 Go",
            "128 Go",
            "256 Go",
            "512 Go",
            "1 To",
            "2 To",
            "Autre"
          ]
        },
        {
          "id": "warranty",
          "name": "Garantie",
          "type": "select",
          "required": false,
          "options": [
            "Sous garantie",
            "Sans garantie"
          ]
        },
        {
          "id": "accessories_included",
          "name": "Accessoires inclus",
          "type": "text",
          "required": false,
          "placeholder": "Ex: chargeur, câble, boîte..."
        }
      ],
      "intro": "Smartphones, ordinateurs, tablettes, audio et appareils photo d'occasion. Vente entre particuliers avec don automatique à une association."
    },
    "vehicles": {
      "id": "vehicles",
      "label": "Véhicules",
      "pillLabel": "Véhicules",
      "icon": "car",
      "slug": "vehicules",
      "seoName": "Véhicules",
      "h1": "Véhicules d'occasion solidaires",
      "types": [
        "sale"
      ],
      "subcategories": [
        {
          "id": "cars",
          "label": "Voitures",
          "slug": "voitures",
          "seoName": "Voitures"
        },
        {
          "id": "motorcycles",
          "label": "Motos",
          "slug": "motos",
          "seoName": "Motos"
        },
        {
          "id": "bikes",
          "label": "Vélos",
          "slug": "velos",
          "seoName": "Vélos"
        },
        {
          "id": "boats",
          "label": "Bateaux",
          "slug": "bateaux",
          "seoName": "Bateaux"
        },
        {
          "id": "campers",
          "label": "Camping-cars",
          "slug": "camping-cars",
          "seoName": "Camping-cars"
        },
        {
          "id": "scooters",
          "label": "Scooters",
          "slug": "scooters",
          "seoName": "Scooters"
        },
        {
          "id": "parts",
          "label": "Pièces & Accessoires",
          "slug": "pieces-auto",
          "seoName": "Pièces & Accessoires"
        }
      ],
      "deprecated": false,
      "attributes": [
        {
          "id": "brand",
          "name": "Marque",
          "type": "select",
          "required": true,
          "options": [
            "Renault",
            "Peugeot",
            "Citroën",
            "Volkswagen",
            "BMW",
            "Mercedes",
            "Audi",
            "Toyota",
            "Ford",
            "Opel",
            "Fiat",
            "Nissan",
            "Hyundai",
            "Kia",
            "Dacia",
            "Autre"
          ]
        },
        {
          "id": "model",
          "name": "Modèle",
          "type": "text",
          "required": true,
          "placeholder": "Ex: Clio, Golf, Série 3..."
        },
        {
          "id": "year",
          "name": "Année",
          "type": "number",
          "required": true,
          "min": 1950,
          "max": 2026,
          "placeholder": "Ex: 2019"
        },
        {
          "id": "mileage",
          "name": "Kilométrage",
          "type": "number",
          "required": true,
          "unit": "km",
          "min": 0,
          "placeholder": "Ex: 85000"
        },
        {
          "id": "fuel",
          "name": "Énergie",
          "type": "select",
          "required": true,
          "options": [
            "Essence",
            "Diesel",
            "Électrique",
            "Hybride",
            "Hybride rechargeable",
            "GPL",
            "Hydrogène",
            "Autre"
          ]
        },
        {
          "id": "gearbox",
          "name": "Boîte de vitesse",
          "type": "select",
          "required": true,
          "options": [
            "Manuelle",
            "Automatique",
            "Semi-automatique"
          ]
        },
        {
          "id": "doors",
          "name": "Nombre de portes",
          "type": "select",
          "required": false,
          "options": [
            "2 portes",
            "3 portes",
            "4 portes",
            "5 portes"
          ]
        },
        {
          "id": "color",
          "name": "Couleur",
          "type": "select",
          "required": false,
          "options": [
            "Blanc",
            "Noir",
            "Gris",
            "Argent",
            "Bleu",
            "Rouge",
            "Vert",
            "Beige",
            "Orange",
            "Autre"
          ]
        },
        {
          "id": "condition",
          "name": "État général",
          "type": "select",
          "required": true,
          "options": [
            "Excellent état",
            "Très bon état",
            "Bon état",
            "État satisfaisant",
            "À rénover",
            "Accidenté"
          ]
        },
        {
          "id": "first_registration",
          "name": "Première mise en circulation",
          "type": "text",
          "required": false,
          "placeholder": "Ex: 03/2019"
        }
      ],
      "intro": "Voitures, motos, vélos, scooters et pièces auto d'occasion. Vente entre particuliers avec une part du prix versée à une association."
    },
    "home": {
      "id": "home",
      "label": "Maison",
      "pillLabel": "Maison",
      "icon": "home",
      "slug": "maison",
      "seoName": "Maison",
      "h1": "Maison & Décoration d'occasion solidaire",
      "types": [
        "sale",
        "rental",
        "free"
      ],
      "subcategories": [
        {
          "id": "furniture",
          "label": "Meubles",
          "slug": "meubles",
          "seoName": "Meubles"
        },
        {
          "id": "decoration",
          "label": "Décoration",
          "slug": "decoration",
          "seoName": "Décoration"
        },
        {
          "id": "garden",
          "label": "Jardin & Extérieur",
          "slug": "jardin",
          "seoName": "Jardin & Extérieur"
        },
        {
          "id": "diy",
          "label": "Bricolage & Outillage",
          "slug": "bricolage",
          "seoName": "Bricolage & Outillage"
        },
        {
          "id": "appliances",
          "label": "Électroménager",
          "slug": "electromenager",
          "seoName": "Électroménager"
        },
        {
          "id": "bedding",
          "label": "Linge de maison",
          "slug": "linge-maison",
          "seoName": "Linge de maison"
        },
        {
          "id": "kitchen",
          "label": "Cuisine & Arts de table",
          "slug": "cuisine",
          "seoName": "Cuisine & Arts de table"
        }
      ],
      "deprecated": false,
      "attributes": [
        {
          "id": "condition",
          "name": "État",
          "type": "select",
          "required": true,
          "options": [
            "Neuf",
            "Très bon état",
            "Bon état",
            "État satisfaisant"
          ]
        },
        {
          "id": "brand",
          "name": "Marque",
          "type": "text",
          "required": false,
          "placeholder": "Ex: IKEA, Dyson, Bosch..."
        },
        {
          "id": "color",
          "name": "Couleur principale",
          "type": "select",
          "required": false,
          "options": [
            "Blanc",
            "Noir",
            "Gris",
            "Beige",
            "Marron",
            "Bleu",
            "Vert",
            "Rouge",
            "Bois naturel",
            "Autre"
          ]
        },
        {
          "id": "dimensions",
          "name": "Dimensions (L x l x H)",
          "type": "text",
          "required": false,
          "placeholder": "Ex: 120 x 60 x 75 cm"
        },
        {
          "id": "material",
          "name": "Matière",
          "type": "select",
          "required": false,
          "options": [
            "Bois",
            "Métal",
            "Plastique",
            "Tissu",
            "Cuir",
            "Verre",
            "Rotin",
            "Autre"
          ]
        }
      ],
      "intro": "Meubles, décoration, électroménager, jardin et bricolage d'occasion. Donnez une seconde vie aux objets de la maison tout en soutenant une cause."
    },
    "fashion": {
      "id": "fashion",
      "label": "Mode",
      "pillLabel": "Mode",
      "icon": "shirt",
      "slug": "mode",
      "seoName": "Mode",
      "h1": "Mode d'occasion solidaire",
      "types": [
        "sale",
        "free"
      ],
      "subcategories": [
        {
          "id": "women",
          "label": "Vêtements femme",
          "slug": "vetements-femme",
          "seoName": "Vêtements femme"
        },
        {
          "id": "men",
          "label": "Vêtements homme",
          "slug": "vetements-homme",
          "seoName": "Vêtements homme"
        },
        {
          "id": "kids_clothes",
          "label": "Vêtements enfant",
          "slug": "vetements-enfant",
          "seoName": "Vêtements enfant"
        },
        {
          "id": "shoes",
          "label": "Chaussures",
          "slug": "chaussures-mode",
          "seoName": "Chaussures"
        },
        {
          "id": "bags",
          "label": "Sacs & Accessoires",
          "slug": "sacs-accessoires",
          "seoName": "Sacs & Accessoires"
        },
        {
          "id": "watches",
          "label": "Montres & Bijoux",
          "slug": "montres-bijoux",
          "seoName": "Montres & Bijoux"
        },
        {
          "id": "lingerie",
          "label": "Lingerie & Sous-vêtements",
          "slug": "lingerie",
          "seoName": "Lingerie & Sous-vêtements"
        }
      ],
      "deprecated": false,
      "attributes": [
        {
          "id": "brand",
          "name": "Marque",
          "type": "text",
          "required": false,
          "placeholder": "Ex: Zara, Nike, Louis Vuitton..."
        },
        {
          "id": "size",
          "name": "Taille",
          "type": "select",
          "required": true,
          "options": [
            "XXS",
            "XS",
            "S",
            "M",
            "L",
            "XL",
            "XXL",
            "XXXL",
            "34",
            "36",
            "38",
            "40",
            "42",
            "44",
            "46",
            "48",
            "50",
            "Taille unique",
            "Autre"
          ]
        },
        {
          "id": "gender",
          "name": "Genre",
          "type": "select",
          "required": true,
          "options": [
            "Femme",
            "Homme",
            "Fille",
            "Garçon",
            "Mixte / Unisexe"
          ]
        },
        {
          "id": "condition",
          "name": "État",
          "type": "select",
          "required": true,
          "options": [
            "Neuf avec étiquette",
            "Neuf sans étiquette",
            "Très bon état",
            "Bon état",
            "Satisfaisant"
          ]
        },
        {
          "id": "color",
          "name": "Couleur principale",
          "type": "select",
          "required": true,
          "options": [
            "Blanc",
            "Noir",
            "Gris",
            "Beige",
            "Bleu",
            "Marine",
            "Vert",
            "Kaki",
            "Rouge",
            "Rose",
            "Jaune",
            "Orange",
            "Violet",
            "Marron",
            "Multicolore",
            "Imprimé"
          ]
        },
        {
          "id": "material",
          "name": "Matière",
          "type": "select",
          "required": false,
          "options": [
            "Coton",
            "Lin",
            "Soie",
            "Laine",
            "Synthétique",
            "Cuir",
            "Daim",
            "Denim",
            "Polyester",
            "Cachemire",
            "Autre"
          ]
        }
      ],
      "intro": "Vêtements, chaussures, sacs et accessoires d'occasion vendus par des particuliers. Chaque achat génère un don à une association choisie par le vendeur."
    },
    "shoes": {
      "id": "shoes",
      "label": "Chaussures",
      "pillLabel": "Chaussures",
      "icon": "shoe",
      "slug": "chaussures",
      "seoName": "Chaussures",
      "h1": "Chaussures d'occasion solidaires",
      "types": [
        "sale",
        "free"
      ],
      "subcategories": [
        {
          "id": "women_shoes",
          "label": "Chaussures femme",
          "slug": "chaussures-femme",
          "seoName": "Chaussures femme"
        },
        {
          "id": "men_shoes",
          "label": "Chaussures homme",
          "slug": "chaussures-homme",
          "seoName": "Chaussures homme"
        },
        {
          "id": "kids_shoes",
          "label": "Chaussures enfant",
          "slug": "chaussures-enfant",
          "seoName": "Chaussures enfant"
        },
        {
          "id": "sport_shoes",
          "label": "Chaussures de sport",
          "slug": "chaussures-sport",
          "seoName": "Chaussures de sport"
        }
      ],
      "deprecated": false,
      "attributes": [
        {
          "id": "brand",
          "name": "Marque",
          "type": "text",
          "required": false,
          "placeholder": "Ex: Nike, Adidas, Converse..."
        },
        {
          "id": "shoe_size",
          "name": "Pointure",
          "type": "select",
          "required": true,
          "options": [
            "35",
            "36",
            "37",
            "38",
            "39",
            "40",
            "41",
            "42",
            "43",
            "44",
            "45",
            "46",
            "47",
            "Autre"
          ]
        },
        {
          "id": "gender",
          "name": "Genre",
          "type": "select",
          "required": true,
          "options": [
            "Femme",
            "Homme",
            "Enfant",
            "Mixte"
          ]
        },
        {
          "id": "condition",
          "name": "État",
          "type": "select",
          "required": true,
          "options": [
            "Neuf",
            "Très bon état",
            "Bon état",
            "État satisfaisant"
          ]
        },
        {
          "id": "color",
          "name": "Couleur",
          "type": "select",
          "required": true,
          "options": [
            "Blanc",
            "Noir",
            "Gris",
            "Beige",
            "Marron",
            "Bleu",
            "Rouge",
            "Rose",
            "Multicolore",
            "Autre"
          ]
        }
      ],
      "intro": "Chaussures femme, homme, enfant et chaussures de sport d'occasion. Soutenez une association à chaque achat."
    },
    "sports": {
      "id": "sports",
      "label": "Sports & Loisirs",
      "pillLabel": "Sports",
      "icon": "dumbbell",
      "slug": "sports-loisirs",
      "seoName": "Sports & Loisirs",
      "h1": "Sports & Loisirs d'occasion solidaire",
      "types": [
        "sale",
        "rental",
        "free"
      ],
      "subcategories": [
        {
          "id": "fitness",
          "label": "Fitness & Musculation",
          "slug": "fitness-musculation",
          "seoName": "Fitness & Musculation"
        },
        {
          "id": "cycling",
          "label": "Vélo",
          "slug": "cyclisme",
          "seoName": "Vélo"
        },
        {
          "id": "water_sports",
          "label": "Sports nautiques",
          "slug": "sports-nautiques",
          "seoName": "Sports nautiques"
        },
        {
          "id": "winter_sports",
          "label": "Sports d'hiver",
          "slug": "sports-hiver",
          "seoName": "Sports d'hiver"
        },
        {
          "id": "team_sports",
          "label": "Sports collectifs",
          "slug": "sports-collectifs",
          "seoName": "Sports collectifs"
        },
        {
          "id": "outdoor",
          "label": "Randonnée & Camping",
          "slug": "randonnee-camping",
          "seoName": "Randonnée & Camping"
        },
        {
          "id": "martial_arts",
          "label": "Arts martiaux",
          "slug": "arts-martiaux",
          "seoName": "Arts martiaux"
        },
        {
          "id": "golf",
          "label": "Golf",
          "slug": "golf",
          "seoName": "Golf"
        }
      ],
      "deprecated": false,
      "attributes": [
        {
          "id": "condition",
          "name": "État",
          "type": "select",
          "required": true,
          "options": [
            "Neuf",
            "Très bon état",
            "Bon état",
            "État satisfaisant"
          ]
        },
        {
          "id": "brand",
          "name": "Marque",
          "type": "text",
          "required": false,
          "placeholder": "Ex: Décathlon, Nike, Salomon..."
        },
        {
          "id": "size",
          "name": "Taille / Dimensions",
          "type": "text",
          "required": false,
          "placeholder": "Ex: M, 54cm (vélo), 170cm (skis)..."
        }
      ],
      "intro": "Matériel de fitness, vélo, sports nautiques et d'hiver d'occasion. Équipez-vous à moindre coût tout en finançant une association."
    },
    "culture": {
      "id": "culture",
      "label": "Livres & Culture",
      "pillLabel": "Livres",
      "icon": "book",
      "slug": "livres-culture",
      "seoName": "Livres & Culture",
      "h1": "Livres & Culture d'occasion solidaire",
      "types": [
        "sale",
        "free"
      ],
      "subcategories": [
        {
          "id": "books",
          "label": "Livres",
          "slug": "livres",
          "seoName": "Livres"
        },
        {
          "id": "music",
          "label": "CD & Vinyles",
          "slug": "cd-vinyles",
          "seoName": "CD & Vinyles"
        },
        {
          "id": "movies",
          "label": "DVD & Blu-ray",
          "slug": "dvd-blu-ray",
          "seoName": "DVD & Blu-ray"
        },
        {
          "id": "comics",
          "label": "BD & Mangas",
          "slug": "bd-mangas",
          "seoName": "BD & Mangas"
        },
        {
          "id": "collectibles",
          "label": "Collections",
          "slug": "collections",
          "seoName": "Collections"
        },
        {
          "id": "instruments",
          "label": "Instruments de musique",
          "slug": "instruments-musique",
          "seoName": "Instruments de musique"
        }
      ],
      "deprecated": false,
      "attributes": [
        {
          "id": "condition",
          "name": "État",
          "type": "select",
          "required": true,
          "options": [
            "Neuf",
            "Comme neuf",
            "Très bon état",
            "Bon état",
            "Acceptable"
          ]
        },
        {
          "id": "author",
          "name": "Auteur / Artiste",
          "type": "text",
          "required": false,
          "placeholder": "Ex: Victor Hugo, Beatles..."
        },
        {
          "id": "edition",
          "name": "Édition / Année",
          "type": "text",
          "required": false,
          "placeholder": "Ex: 2020, 1ère édition..."
        },
        {
          "id": "language",
          "name": "Langue",
          "type": "select",
          "required": false,
          "options": [
            "Français",
            "Anglais",
            "Espagnol",
            "Allemand",
            "Italien",
            "Autre"
          ]
        }
      ],
      "intro": "Livres, BD, CD, vinyles, DVD et instruments de musique d'occasion. Une seconde vie pour la culture, un don pour une cause."
    },
    "kids": {
      "id": "kids",
      "label": "Enfants & Bébés",
      "pillLabel": "Enfants",
      "icon": "baby",
      "slug": "enfants-bebes",
      "seoName": "Enfants & Bébés",
      "h1": "Enfants & Bébés d'occasion solidaire",
      "types": [
        "sale",
        "rental",
        "free"
      ],
      "subcategories": [
        {
          "id": "toys",
          "label": "Jouets",
          "slug": "jouets",
          "seoName": "Jouets"
        },
        {
          "id": "clothes",
          "label": "Vêtements",
          "slug": "vetements-bebe",
          "seoName": "Vêtements bébé"
        },
        {
          "id": "strollers",
          "label": "Poussettes & Sièges auto",
          "slug": "poussettes-sieges-auto",
          "seoName": "Poussettes & Sièges auto"
        },
        {
          "id": "nursery",
          "label": "Puériculture",
          "slug": "puericulture",
          "seoName": "Puériculture"
        },
        {
          "id": "education",
          "label": "Jeux éducatifs",
          "slug": "jeux-educatifs",
          "seoName": "Jeux éducatifs"
        },
        {
          "id": "school",
          "label": "Fournitures scolaires",
          "slug": "fournitures-scolaires",
          "seoName": "Fournitures scolaires"
        }
      ],
      "deprecated": false,
      "attributes": [
        {
          "id": "age_range",
          "name": "Tranche d'âge",
          "type": "select",
          "required": true,
          "options": [
            "0-6 mois",
            "6-12 mois",
            "1-2 ans",
            "2-4 ans",
            "4-6 ans",
            "6-8 ans",
            "8-12 ans",
            "12+ ans",
            "Tous âges"
          ]
        },
        {
          "id": "condition",
          "name": "État",
          "type": "select",
          "required": true,
          "options": [
            "Neuf",
            "Très bon état",
            "Bon état",
            "État satisfaisant"
          ]
        },
        {
          "id": "brand",
          "name": "Marque",
          "type": "text",
          "required": false,
          "placeholder": "Ex: LEGO, Fisher-Price, Chicco..."
        },
        {
          "id": "gender",
          "name": "Pour",
          "type": "select",
          "required": false,
          "options": [
            "Fille",
            "Garçon",
            "Mixte"
          ],
          "required_subcategories": [
            "clothes"
          ]
        },
        {
          "id": "size",
          "name": "Taille",
          "type": "select",
          "required": true,
          "only_subcategories": [
            "clothes"
          ],
          "options": [
            "Naissance",
            "1 mois",
            "3 mois",
            "6 mois",
            "9 mois",
            "12 mois",
            "18 mois",
            "2 ans",
            "3 ans",
            "4 ans",
            "5 ans",
            "6 ans",
            "8 ans",
            "10 ans",
            "12 ans",
            "14 ans",
            "16 ans",
            "Autre"
          ]
        },
        {
          "id": "color",
          "name": "Couleur principale",
          "type": "select",
          "required": true,
          "only_subcategories": [
            "clothes"
          ],
          "options": [
            "Blanc",
            "Noir",
            "Gris",
            "Beige",
            "Bleu",
            "Marine",
            "Vert",
            "Kaki",
            "Rouge",
            "Rose",
            "Jaune",
            "Orange",
            "Violet",
            "Marron",
            "Multicolore",
            "Imprimé"
          ]
        }
      ],
      "intro": "Jouets, vêtements bébé, poussettes, sièges auto et puériculture d'occasion. Équipez-vous bébé sans gaspiller, en soutenant une association."
    },
    "pets": {
      "id": "pets",
      "label": "Animaux",
      "pillLabel": "Animaux",
      "icon": "paw",
      "slug": "animaux",
      "seoName": "Animaux",
      "h1": "Animaux & Accessoires d'occasion solidaire",
      "types": [
        "sale",
        "free"
      ],
      "subcategories": [
        {
          "id": "accessories",
          "label": "Accessoires",
          "slug": "accessoires-animaux",
          "seoName": "Accessoires"
        },
        {
          "id": "food",
          "label": "Alimentation",
          "slug": "alimentation-animaux",
          "seoName": "Alimentation"
        },
        {
          "id": "housing",
          "label": "Cages & Enclos",
          "slug": "cages-enclos",
          "seoName": "Cages & Enclos"
        },
        {
          "id": "care",
          "label": "Soins & Hygiène",
          "slug": "soins-animaux",
          "seoName": "Soins & Hygiène"
        },
        {
          "id": "adopt",
          "label": "Adoption",
          "slug": "adoption",
          "seoName": "Adoption"
        }
      ],
      "deprecated": false,
      "attributes": [
        {
          "id": "animal_type",
          "name": "Type d'animal",
          "type": "select",
          "required": true,
          "options": [
            "Chien",
            "Chat",
            "Oiseau",
            "Rongeur",
            "Lapin",
            "Poisson",
            "Reptile",
            "Cheval",
            "Autre"
          ]
        },
        {
          "id": "condition",
          "name": "État",
          "type": "select",
          "required": true,
          "options": [
            "Neuf",
            "Très bon état",
            "Bon état"
          ]
        },
        {
          "id": "brand",
          "name": "Marque",
          "type": "text",
          "required": false,
          "placeholder": "Ex: Royal Canin, Ferplast..."
        }
      ],
      "intro": "Accessoires, alimentation, cages et soins pour animaux de compagnie. Soutenez une asso de protection animale à chaque achat."
    },
    "services": {
      "id": "services",
      "label": "Services",
      "pillLabel": "Services",
      "icon": "wrench",
      "slug": "services",
      "seoName": "Services",
      "h1": "Services solidaires entre particuliers",
      "types": [
        "sale",
        "service",
        "free"
      ],
      "subcategories": [
        {
          "id": "lessons",
          "label": "Cours particuliers",
          "slug": "cours-particuliers",
          "seoName": "Cours particuliers",
          "serviceType": true
        },
        {
          "id": "events",
          "label": "Événements",
          "slug": "evenements",
          "seoName": "Événements",
          "serviceType": true
        },
        {
          "id": "transport",
          "label": "Transport & Déménagement",
          "slug": "transport-demenagement",
          "seoName": "Transport & Déménagement",
          "serviceType": true
        },
        {
          "id": "home_services",
          "label": "Services à domicile",
          "slug": "services-a-domicile",
          "seoName": "Services à domicile",
          "serviceType": true
        },
        {
          "id": "beauty",
          "label": "Beauté & Bien-être",
          "slug": "beaute-bien-etre",
          "seoName": "Beauté & Bien-être",
          "serviceType": true
        },
        {
          "id": "repairs",
          "label": "Réparations",
          "slug": "reparations",
          "seoName": "Réparations",
          "serviceType": true
        },
        {
          "id": "other",
          "label": "Autre",
          "slug": null,
          "seoName": null,
          "_seoExcluded": true,
          "_note": "catch-all volontairement hors SEO (anti thin-content), cf. categories.py"
        }
      ],
      "deprecated": false,
      "attributes": [
        {
          "id": "service_type",
          "name": "Type de prestation",
          "type": "select",
          "required": true,
          "options": [
            "Ponctuel",
            "Récurrent",
            "À la demande",
            "Abonnement"
          ]
        },
        {
          "id": "experience",
          "name": "Expérience",
          "type": "select",
          "required": false,
          "options": [
            "Débutant",
            "Intermédiaire",
            "Expert",
            "Professionnel certifié"
          ]
        },
        {
          "id": "availability",
          "name": "Disponibilité",
          "type": "select",
          "required": false,
          "options": [
            "Semaine",
            "Week-end",
            "Semaine & Week-end",
            "Soir uniquement",
            "Flexible"
          ]
        }
      ],
      "intro": "Cours particuliers, événements, transport, services à domicile, beauté et réparations. Faites appel à un particulier qui finance une cause."
    },
    "other": {
      "id": "other",
      "label": "Autres",
      "pillLabel": "Autres",
      "icon": "box",
      "slug": "divers",
      "seoName": "Divers",
      "h1": "Annonces diverses solidaires",
      "types": [
        "sale",
        "rental",
        "free"
      ],
      "subcategories": [],
      "deprecated": false,
      "attributes": [
        {
          "id": "condition",
          "name": "État",
          "type": "select",
          "required": false,
          "options": [
            "Neuf",
            "Très bon état",
            "Bon état",
            "État satisfaisant"
          ]
        }
      ],
      "intro": "Toutes les annonces qui ne rentrent dans aucune autre catégorie. Vente d'occasion entre particuliers avec don à une association."
    }
  },
  "generatedAt": "2026-07-06"
};

export default TAXONOMY;
